<template>
  <router-view class="h-screen overflow-hidden"/>
</template>

<style>
* {
  font-family: 'Poppins', sans-serif;
}
</style>
